/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDriverManagerProfile.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/planning/driver-manager-profile";

export class AutogenModelDriverManagerProfile<RowType extends ModelRow> extends Endpoint<RowType, RowDriverManagerProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDriverManagerProfile extends ModelRow<RowDriverManagerProfileFields> {
	constructor(values?: Partial<RowDriverManagerProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDriverManagerProfileFields {
	active_status: string;
	company_id: string;
	default_vertical_tab: string;
	default_view: string;
	driver_gridconfig: string;
	driver_managers: string;
	id: string;
	include_without_drv_mgr: string;
}

